import type { City, ListResponseCity } from "@classes-service-types/index.ts";
import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import type { Ref } from "vue";
import { computed, unref } from "vue";
import citiesService from "@/services/cities.js";

export interface Args<TData = City[]> {
  limit: Ref<number> | number;
  page: number;
  in_use?: Ref<boolean> | boolean;
  city_ascii?: Ref<string> | string;
  city_ids?: Ref<number[]> | number[];
  useQueryOptions?: Partial<UseQueryOptions<City[], Error, TData>>;
}

export const useGetCitiesData = <TData = City[]>({
  limit,
  page,
  in_use,
  city_ascii,
  city_ids,
  useQueryOptions,
}: Args<TData>) => {
  const fetchCities = (): Promise<ListResponseCity["data"]["items"]> =>
    citiesService
      .getCities({
        limit: unref(limit),
        city_ascii: unref(city_ascii) ?? "",
        in_use: unref(in_use) ?? true,
        page: page,
        city_ids: unref(city_ids)?.length ? unref(city_ids) : null,
      })
      .then((val: { data: ListResponseCity }) => val?.data?.data?.items);

  return useQuery<City[], Error, TData>({
    queryKey: computed(() => ["fetchCitiesData", limit, page, city_ascii, city_ids]),
    queryFn: fetchCities,
    ...useQueryOptions,
  });
};
